import React from 'react';
import FundRequestForm from 'src/components/forms/fundRequest/PDForms/FundRequestForm';
import FundRequestGeneralTreasuryForm from 'src/components/forms/fundRequest/PDForms/FundRequestGeneralTreasuryForm';
import FundPermanentRequestForm from 'src/components/forms/fundRequest/PDForms/FundPermanentRequestForm';
import FundRequestProvisionAgainstDeliveryForm from 'src/components/forms/fundRequest/PDForms/FundRequestProvisionAgainstDeliveryForm';
import fundRequestSubsidiesForm from 'src/components/forms/fundRequest/PDForms/FundRequestSubsidiesForm';
import ProvidersFundRequestForm from 'src/components/forms/fundRequest/PDForms/ProvidersFundRequestForm';
import NewHaberesFundRequestForm from './PDForms/NewHaberesFundRequestForm';
import FundRequestManualForm from './PDForms/FundRequestManualForm';
import fundRequestLoanForm from "src/components/forms/fundRequest/PDForms/FundRequestLoanForm";
import fundRequestATNForm from "src/components/forms/fundRequest/PDForms/FundRequestATNForm";

const PDFormFactory = props => {

	const { formName } = props;

	const namesMap = {
		'PEDIDO_DE_FONDOS': FundRequestForm,
		'PEDIDO_DE_FONDOS_MANUAL': FundRequestManualForm,
		'PEDIDO_DE_FONDOS_DE_PROVEEDORES': ProvidersFundRequestForm,
		'PEDIDO_DE_FONDOS_DE_HABERES': NewHaberesFundRequestForm,
		'PEDIDO_DE_FONDOS_DE_HABERES_MULTIPLES': NewHaberesFundRequestForm,
		'PEDIDO_DE_FONDOS_DE_EROGACIONES_FIGURATIVAS': '',
		'PEDIDO_DE_FONDOS_DE_INSTITUCION_DE_FONDOS_PERMANENTES': FundPermanentRequestForm,
		'PEDIDO_DE_FONDOS_DE_REINTEGRO_TESORERIA_GENERAL': FundRequestGeneralTreasuryForm,
		'PEDIDO_DE_FONDOS_DE_CONTADO_CONTRA_ENTREGA': FundRequestProvisionAgainstDeliveryForm,
		'PEDIDO_DE_FONDOS_DE_ANTICIPO_DE_CUENTA_RENTAS_GENERALES': '',
		'PEDIDO_DE_FONDOS_DE_ANTICIPO_DE_CUENTA_RENTAS_GENERALES_HABERES': '',
		'PEDIDO_DE_FONDOS_DE_SUBSIDIOS': fundRequestSubsidiesForm,
		'PEDIDO_DE_FONDOS_DE_PRESTAMO': fundRequestLoanForm,
		'PEDIDO_DE_FONDOS_DE_APORTES_TESORO_NACIONAL': fundRequestATNForm,
	};

	const calcTemplate = formName => {
		return namesMap[formName] ? React.createElement(namesMap[formName]) : <> Pedido de Fondo sin establecer </>;
	}

	return (
		calcTemplate(formName)
	);
}

export default PDFormFactory;